import(/* webpackMode: "eager" */ "/var/www/nextjs-blue/src/app/error.tsx");
